import Vue from 'vue'
import '@/style/reset.css';//引入默认样式
import '@/style/default.css';
import '@/style/hover.css';
import App from './components/BaseLayout/Layout.vue'
import store from './store/index';
import router from './router/index';

Vue.config.productionTip = false;


//引入axios
import axios from "axios";
Vue.prototype.axios = axios;
//引入 接口api地址
import { domain } from './api/apiConfig.js'
//引入 baseApi
import common from './api/baseApi.js'
Vue.use(common);
//配置axios
//->1,模块一接口,url地址
axios.defaults.InApi = domain.InApi;
//->2,模块二接口,url地址
axios.defaults.OutApi = domain.OutApi;
//->3,测试,url地址
axios.defaults.TestApi = domain.TestApi;


//引入iview
import 'view-design/dist/styles/iview.css';
import { Button, Table,Icon,Tabs,TabPane,Page,Steps,Input,Radio,Checkbox,Select,Option,DatePicker,Upload,Form,FormItem,Alert,Notice,Message,Modal,Spin,Card,AutoComplete,RadioGroup,DropdownMenu,Dropdown } from 'view-design';
Vue.component('Button', Button);
Vue.component('Table', Table);
Vue.component('Icon', Icon);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Page', Page);
Vue.component('Steps', Steps);
Vue.component('Input', Input);
Vue.component('Radio', Radio);
Vue.component('Checkbox', Checkbox);
Vue.component('Select', Select);
Vue.component('Option',Option);
Vue.component('DatePicker', DatePicker);
Vue.component('Upload', Upload);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Alert', Alert);
Vue.prototype.$Notice= Notice;
Vue.prototype.$Message=Message;
Vue.prototype.$Modal=Modal;
Vue.component('Modal', Modal);
Vue.component('Spin', Spin);
Vue.component('Card',Card);
Vue.component('AutoComplete',AutoComplete);
Vue.component('RadioGroup',RadioGroup);
Vue.component('DropdownMenu',DropdownMenu);
Vue.component('Dropdown',Dropdown);

if (!Array.prototype.findIndex) {
  Array.prototype.findIndex = function(callback) {
    return callback && (this.filter(callback) || [])[0];
  };
}
if (!Array.prototype.includes) {
  Array.prototype.includes = function(callback) {
    return callback && (this.filter(callback) || [])[0];
  };
}
if (!Array.prototype.find) {
  Array.prototype.find = function(callback) {
    return callback && (this.filter(callback) || [])[0];
  };
}

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {ak: 'kLYjqhRAYGtR4HC5IvgNIfsGC91BHGzO'});


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  //console.log(to)
  if(to.path=="/"){return false;}
  if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
    if(to.path=="/PublicAnnouncementList"||to.path=="/SalesNetworkList"||to.path=="/OperationManualList"){//这里暂且这么写写，以后有空把逻辑理一理xiaohang20201203
      next();
    }else if (localStorage.getItem('token')) { // 判断当前的token是否存在
      next();
    }else {
      next({
        path: '/',
        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
  else {
    //if (localStorage.getItem('token')||to.path=="/PersonalBusinessList") { // 判断当前的token是否存在
    if ((localStorage.getItem('token')&&localStorage.getItem("G_Roles"))||to.path=="/PersonalBusinessList") {
      next();
    }else{
      if(store.state.CanShowModal.ModalStatus==false){
        Message.warning('请先注册或登录！');
        store.commit("CanShowModal",true);
        store.commit("ChangeUserName","");
      }
    }
  }
});

